/**
 * The Help-page FAQ list — the single source of truth for help questions.
 *
 * Consumed by `useHelp` (renders the page) and by `RouteSEO` (builds the
 * FAQPage JSON-LD for /help). `questionKey` / `answerKey` index `t.help`.
 */
export const HELP_FAQ_ITEMS = [
  // Getting Started
  { category: "getting-started", questionKey: "faq1Q", answerKey: "faq1A" },
  { category: "getting-started", questionKey: "faq2Q", answerKey: "faq2A" },
  { category: "getting-started", questionKey: "faq3Q", answerKey: "faq3A" },
  { category: "getting-started", questionKey: "faq4Q", answerKey: "faq4A" },
  // Image Creation
  { category: "images", questionKey: "faq5Q", answerKey: "faq5A" },
  { category: "images", questionKey: "faq6Q", answerKey: "faq6A" },
  { category: "images", questionKey: "faq7Q", answerKey: "faq7A" },
  // Video Creation
  { category: "videos", questionKey: "faq8Q", answerKey: "faq8A" },
  { category: "videos", questionKey: "faq9Q", answerKey: "faq9A" },
  { category: "videos", questionKey: "faq10Q", answerKey: "faq10A" },
  // Editing
  { category: "editing", questionKey: "faq11Q", answerKey: "faq11A" },
  { category: "editing", questionKey: "faq12Q", answerKey: "faq12A" },
  // Tokens & Pricing
  { category: "credits", questionKey: "faq13Q", answerKey: "faq13A" },
  { category: "credits", questionKey: "faq14Q", answerKey: "faq14A" },
  { category: "credits", questionKey: "faq15Q", answerKey: "faq15A" },
  { category: "credits", questionKey: "faq16Q", answerKey: "faq16A" },
  // Account
  { category: "account", questionKey: "faq17Q", answerKey: "faq17A" },
  { category: "account", questionKey: "faq18Q", answerKey: "faq18A" },
  // Technical
  { category: "technical", questionKey: "faq19Q", answerKey: "faq19A" },
  { category: "technical", questionKey: "faq20Q", answerKey: "faq20A" },
  { category: "technical", questionKey: "faq21Q", answerKey: "faq21A" },
] as const;
